'use strict';

var NavigationSectionConfig = function NavigationSectionConfig() {
  return {
    'app.default': 'Dashboard',
    'app.dashboard': 'Dashboard',
    'app.data-extract': 'Data Extract',
    'app.market-analysis': 'Market Analysis',
    'app.market-analysis.demand-transparency': 'Demand Transparency',
    'app.market-analysis.demand-posting': 'Demand Posting',
    'app.flight-analysis': 'Flight Analysis',
    'app.flight-analysis.flight-management': 'Flight Management',
    'app.rules': 'Rules',
    'app.schedule-change': 'Schedule Change',
    'app.strategies': 'Strategies',
    'app.system-status': 'System Status',
    'app.system-configuration': 'System Configuration',
    'app.user-exclusions': 'User Exclusions',
    'app.seasonality': 'Seasonality',
    'app.calibration-analysis': 'Calibration',
    'app.fares': 'Fares Analysis',
    'app.rom-analysis': 'ROM Analysis View',
    'app.rom-summary': 'ROM Summary View',
    'app.user-management': 'User Management',
    'app.user-profile': 'My Profile',
    'app.pricing-summary': 'Dashboard',
    'app.pricing-analysis': 'Departure Date Upsell',
    'app.fares-optimizer-analysis': 'Pricing Analysis',
    'app.fo-dashboard': 'Dashboard',
    'app.fo-core-pricing': 'Core Pricing'
  };
};
module.exports = NavigationSectionConfig;